// extracted by mini-css-extract-plugin
export var footer = "gh_s2";
export var footer_company = "gh_v2";
export var footer_link = "gh_w2";
export var footer_social = "gh_t2";